import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteQuestionTagMutation, deleteQuestionTagMutationVariables } from '../generated/deleteQuestionTagMutation';
import { questionTagFieldsFragment } from '../models/QuestionTag';

/**
 * Get a callback to delete a QuestionTag in the store.
 */
export function useDeleteQuestionTagCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteQuestionTagMutation, deleteQuestionTagMutationVariables>(
        gql`
            mutation deleteQuestionTagMutation ($id: ID!) {
                deleteQuestionTag(id: $id) {
                    ...questionTagFields
                }
            }

            ${questionTagFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
